import AppraisalEditForm from "../pages/Form Edit/AppraisalEditForm";
import AppraisalForm from "../pages/Form Add/AppraisalForm";
import EmployeePreviousResponses from "../pages/Form View/EmployeePreviousResponses";
import EmployeeSpecificResponse from "../pages/Form View/EmployeeSpecificResponse";
import LogIn from "../pages/Login/LogIn";
import AdminAddEmployee from "../pages/All Employee/AdminAddEmployee";
import AllEmployee from "../pages/All Employee/AllEmployee";
import Dashboard from "../pages/Dashboard/Dashboard";
import FillOrSaveAppraisalForm from "../pages/Form Fill/FillOrSaveAppraisalForm";
import AppraisalViewForm from "../pages/Form View/AppraisalViewForm";
import CreatedFroms from "../pages/Form View/CreatedFroms";
import ManagerAppraisal from "../pages/Manager Form Fill/ManagerAppraisal";
// import Permission from "../pages/Permission/Permission"; // COMMENTED OUT - Permission functionality hidden
import Profile from "../pages/Profile/Profile";
// import Ranking from "../pages/Ranking/Ranking"; // COMMENTED OUT - Ranking functionality hidden
import FinalResponse from "../pages/Review/FinalResponse";
import ReviewDownload from "../pages/Review/ReviewDownload";
import ReviewDownloadAdmin from "../pages/Review/ReviewDownloadAdmin";
import ReviewForm from "../pages/Dashboard/ReviewForm";
import ShowAppraisalSpecificAdmin from "../pages/Review/ShowAppraisalSpecificAdmin";
import ShowAppraisalSpecificHr from "../pages/Review/ShowAppraisalSpecificHr";
import ShowResponseAppraisalForm from "../pages/Review/ShowResponseAppraisalForm";
import SuperAdminreview from "../pages/Review/SuperAdminreview";
// import Subordinates from "../pages/Subordinate/Subordinates"; // COMMENTED OUT - Subordinate functionality hidden
import CreateTeam from "../pages/Team/CreateTeam";
import ProjectManagement from "../pages/Projects/ProjectManagement";
import ProjectDetailPage from "../pages/Projects/ProjectDetailPage";
import AddEmployee from "../pages/All Employee/AddEmployee";
import ViewEmployee from "../pages/All Employee/ViewEmployee";
import EmployeeJiraAnalyticsPage from "../pages/All Employee/EmployeeJiraAnalyticsPage";
import AddTeam from "../pages/Team/AddTeam";
import EditTeam from "../pages/Team/EditTeam";
import ViewTeam from "../pages/Team/ViewTeam";
// import HrAndAdminRanking from "../pages/Ranking/HrAndAdminRanking"; // COMMENTED OUT - Ranking functionality hidden
import ForgotPassword from "../components/Forgot Password/ForgotPassword";
// COMMENTED OUT - Forms functionality hidden
// import FormAdd from "../pages/Form Add/FormAdd";
// import AllCreatedForms from "../pages/Form View/AllCreatedForms";
import AllPreviousResponses from "../pages/Form View/AllPreviousResponses";
// import AllFormView from "../pages/Form View/AllFormView";
// import EditAllForms from "../pages/Form Edit/EditAllForms";
// import AllFillForm from "../pages/Form Fill/AllFillForm";
import ShowThreeSixtyFormReview from "../pages/Review/ThreeSixtyForm/ShowThreeSixtyFormReview";
import ThreeSixtySpecificPreviousResponse from "../pages/Form View/ThreeSixtyForm/ThreeSixtySpecificPreviousResponse";
import ProfileSectionLayout from "../pages/Profile/ProfileSectionLayout";
import SkillsAddOrEdit from "../pages/Skill Set/SkillsAddOrEdit";
import ShowFeedBackFormReview from "../pages/Review/FeedBackForm/ShowFeedBackFormReview";
import DataPoints from "../pages/DataPoints/DataPoints";
import AllCharts from "../pages/AllCharts";
import SkilledEmployee from "../pages/SkilledEmployee/SkilledEmployee";
import HistoricalAppraisalChart from "../pages/ProjectRatings/HistoricAppraisalChart";
import ProcessComplianceTemplates from "../pages/Compliance/ProcessComplianceTemplates";
import ProcessComplianceAssignments from "../pages/Compliance/ProcessComplianceAssignments";
import ProcessComplianceForm from "../pages/Compliance/ProcessComplianceForm";
import ComplianceDashboard from "../pages/Compliance/ComplianceDashboard";
import ManagerCompliance from "../pages/Compliance/ManagerCompliance";
import EmployeeSkillSet from "../pages/Skill Set/EmployeeSkillSet";
import ViewAllSkills from "../pages/Skill Set/ViewAllSkills";
import EmployeeAttendance from "../pages/Attendance/EmployeeAttendance";
import ViewAttendaceRecords from "../pages/Attendance/ViewAttendaceRecords";
// COMMENTED OUT - Feedback section hidden (PMS feedback remains active)
// import HrAppraisal from "../pages/Dashboard/Appraisal/HrAppraisal";
import MainLayout from "../components/Page Component/MainLayout";
// import EmpAppraisal from "../pages/Dashboard/EmpAppraisal";
// import ManagerAppraisalComponent from "../pages/Dashboard/ManagerAppraisalComponent";
// import AdminAppraisal from "../pages/Dashboard/AdminAppraisal";
// import ThreeSixtyAdminDashboard from "../pages/Dashboard/ThreeSixtyForm/ThreeSixtyAdminDashboard";
// import ThreeSixtyEmployeeDashboard from "../pages/Dashboard/ThreeSixtyForm/ThreeSixtyEmployeeDashboard";
// import ThreeSixtyHRDashboard from "../pages/Dashboard/ThreeSixtyForm/ThreeSixtyHRDashboard";
// import ThreeSixtyManagerDashboard from "../pages/Dashboard/ThreeSixtyForm/ThreeSixtyManagerDashboard";
// import FeedBackFormDashboard from "../pages/Dashboard/FeedBackForm/FeedBackFormDashboard";
// import FeedBackFormHRDashboard from "../pages/Dashboard/FeedBackForm/FeedBackFormHRDashboard";
// import FeedBackFormManagerDashboard from "../pages/Dashboard/FeedBackForm/FeedBackFormManagerDashboard";
import LandingPage from "../pages/NewDashboard/LandingPage";
import SkillDocument from "../pages/Skill Set/SkillDocument";
import EmployeeSkillsDocuments from "../pages/Skill Set/EmployeeSkillsDocuments";
import ManageAssignments from "../pages/Employee/ManageAssignments";
import AssignManager from "../pages/Employee/AssignManager";
import ManagerAssignmentHistory from "../components/Employee/ManagerAssignmentHistory";
import { Navigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { Route, Routes } from "react-router-dom";
import DesignationsList from "../pages/PMS/Designations/DesignationsList";
import DesignationDetail from "../pages/PMS/Designations/DesignationDetail";
import AllKRATemplates from "../pages/PMS/KRA/AllKRATemplates";
import CreateKRAForm from "../pages/PMS/KRA/CreateKRAForm";
import AssignKRAForm from "../pages/PMS/KRA/AssignKRAForm";
import EmployeeKRAView from "../pages/PMS/KRA/EmployeeKRAView";
import EmployeeSelfReviewDashboard from "../pages/PMS/KRA/EmployeeSelfReviewDashboard";
import ManagerKRAReview from "../pages/PMS/KRA/ManagerKRAReview";
import HRReview from "../pages/PMS/KRA/HRReview";
import KRAAssignments from "../pages/PMS/KRA/KRAAssignments";
import Feedback360 from "../pages/PMS/KRA/Feedback360";
import Manager360FeedbackView from "../pages/PMS/KRA/Manager360FeedbackView";
import HR360FeedbackDashboard from "../pages/PMS/KRA/HR360FeedbackDashboard";
import CustomerFeedbackForm from "../pages/Public/CustomerFeedbackForm";
import FeedbackRequestList from "../pages/Feedback/FeedbackRequestList";
import ViewCustomerFeedback from "../pages/Feedback/ViewCustomerFeedback";
import FeedbackTemplateManager from "../pages/Feedback/FeedbackTemplateManager";


const LinkRoutes = () => {
  const isLogged = useSelector((state: any) => state.auth.isLoggedIn); // Replace this with actual login state

  return (
    <Routes>
      {/* Public routes */}
      <Route path="/login" element={<LogIn />} />
      <Route path="/forgotpassword" element={<ForgotPassword />} />
      <Route path="/feedback/:token" element={<CustomerFeedbackForm />} />
      <Route
        path="/*"
        element={
          isLogged ? (
              <MainLayout />
          ) : (
            <Navigate to="/login" />
          )
        }
      >
        {/* <Route index element={<Dashboard />} /> */}
        <Route index element={<LandingPage />} />
        <Route path="landing" element={<LandingPage />} />
        <Route path="createteam" element={<CreateTeam />} />
        <Route path="addTeam" element={<AddTeam />} />
        <Route path="projects" element={<ProjectManagement />} />
        <Route path="projects/:projectId" element={<ProjectDetailPage />} />
        <Route path="editTeam" element={<EditTeam />} />
        <Route path="viewTeam" element={<ViewTeam />} />
        <Route path="managerreview" element={<ManagerAppraisal />} />
        {/* COMMENTED OUT - Ranking functionality hidden */}
        {/* <Route path="HrRanking" element={<HrAndAdminRanking />} /> */}
        {/* COMMENTED OUT - Forms functionality hidden */}
        {/* <Route path="editform" element={<EditAllForms />} /> */}
        <Route path="dashboard" element={<Dashboard />} />
        {/* <Route path="addForm" element={<FormAdd />} /> */}
        {/* <Route path="createdforms" element={<AllCreatedForms />} /> */}
        {/* <Route path="fillForm" element={<AllFillForm />} /> */}
        {/* <Route path="viewform" element={<AllFormView />} /> */}
        <Route path="employeeinformation" element={<AllEmployee />} />
        <Route path="employeeinformation/:employeeId" element={<EmployeeJiraAnalyticsPage />} />
        {/* Assign Manager sidebar shows the list page */}
        {/* <Route path="assign-manager" element={<ManageAssignments />} /> */} 
        {/* Form accessible from the list */}
        <Route path="assign-manager/form" element={<AssignManager />} />
        <Route path="manager-history" element={<ManagerAssignmentHistory />} />
        <Route path="addEmployee" element={<AddEmployee />} />
        <Route path="viewEmployee" element={<ViewEmployee />} />
        <Route path="addemployee" element={<AdminAddEmployee />} />
        {/* COMMENTED OUT - Ranking functionality hidden */}
        {/* <Route path="Ranking" element={<Ranking />} /> */}
        {/* <Route path="HARanking" element={<HrAndAdminRanking />} /> */}
        <Route path="reviewForm" element={<ReviewForm />} />
        <Route path="reviews" element={<SuperAdminreview />} />
        <Route path="profile" element={<ProfileSectionLayout />} />
        <Route path="final" element={<FinalResponse />} />
        {/* COMMENTED OUT - Subordinate functionality hidden */}
        {/* <Route path="subordinate" element={<Subordinates />} /> */}
        {/* COMMENTED OUT - Permission functionality hidden */}
        {/* <Route path="permission" element={<Permission />} /> */}
        <Route path="logout" element={<LogIn />} />
        <Route path="showresponse" element={<ShowResponseAppraisalForm />} />
        <Route
          path="showspecificresponse"
          element={<ShowAppraisalSpecificAdmin />}
        />
        <Route
          path="showspecificresponsehr"
          element={<ShowAppraisalSpecificHr />}
        />
        <Route path="download" element={<ReviewDownload />} />
        <Route path="previousresponses" element={<AllPreviousResponses />} />
        <Route path="downloadadmin" element={<ReviewDownloadAdmin />} />
        <Route
          path="showthreesixtyformresponse"
          element={<ShowThreeSixtyFormReview />}
        />
        <Route
          path="employeepreviousresponse"
          element={<EmployeeSpecificResponse />}
        />
        <Route
          path="employee360previousresponse"
          element={<ThreeSixtySpecificPreviousResponse />}
        />
        <Route path="forgotpassword" element={<ForgotPassword />} />
        <Route path="addoreditskills" element={<SkillsAddOrEdit />} />
        <Route
          path="showfeedbackresponse"
          element={<ShowFeedBackFormReview />}
        />
        <Route path="datapoints" element={<DataPoints />} />
        <Route path="utilization" element={<AllCharts />} />
        <Route path="skill-based-employee" element={<SkilledEmployee />} />
        <Route path="skill-document" element={<SkillDocument />} />
        
        <Route
          path="historical-appraisal"
          element={<HistoricalAppraisalChart />}
        />
        <Route
          path="process-compliance-templates"
          element={<ProcessComplianceTemplates />}
        />
        <Route
          path="process-compliance-assignments"
          element={<ProcessComplianceAssignments />}
        />
        <Route
          path="process-compliance-form/:assignmentId"
          element={<ProcessComplianceForm />}
        />
        <Route path="compliance-dashboard" element={<ComplianceDashboard />} />
        <Route path="compliance-templates" element={<ManagerCompliance />} />
        <Route path="employee-skill-set" element={<EmployeeSkillSet />} />
        <Route path="all-skills" element={<ViewAllSkills />} />
        <Route path="emp-skills-document" element={<EmployeeSkillsDocuments />} />
        <Route path="employee-attendance" element={<EmployeeAttendance />} />
        <Route path="all-attendance" element={<ViewAttendaceRecords />} />
        {/* Route for direct attendance access - redirects to all-attendance for Manager/HR/Admin */}
        <Route path="attendance" element={<ViewAttendaceRecords />} />
        {/* COMMENTED OUT - Feedback section hidden (PMS feedback remains active) */}
        {/* <Route path="hr-appraisal" element={<HrAppraisal />} /> */}
        {/* <Route path="employee-appraisal" element={<EmpAppraisal />} /> */}
        {/* <Route path="admin-appraisal" element={<AdminAppraisal />} /> */}
        {/* <Route path="manager-appraisal-component" element={<ManagerAppraisalComponent />} /> */}
        {/* <Route path="manager-appraisal" element={<ManagerAppraisalComponent />} /> */}
        {/* <Route path="three-sixty-admin" element={<ThreeSixtyAdminDashboard />} /> */}
        {/* <Route path="three-sixty-employee" element={<ThreeSixtyEmployeeDashboard />} /> */}
        {/* <Route path="three-sixty-hr" element={<ThreeSixtyHRDashboard />} /> */}
        {/* <Route path="three-sixty-manager" element={<ThreeSixtyManagerDashboard />} /> */}
        {/* <Route path="feedback-dashboard" element={<FeedBackFormDashboard />} /> */}
        {/* <Route path="feedback-hr-dashboard" element={<FeedBackFormHRDashboard />} /> */}
        {/* <Route path="feedback-manager-dashboard" element={<FeedBackFormManagerDashboard />} /> */}
        {/* PMS - KRA Routes */}
        <Route path="pms/designations" element={<DesignationsList />} />
        <Route path="pms/designations/new" element={<DesignationDetail mode="create" />} />
        <Route path="pms/designations/:id" element={<DesignationDetail mode="edit" />} />
        <Route path="pms/kra/library" element={<AllKRATemplates />} />
        <Route path="pms/kra/create" element={<CreateKRAForm />} />
        <Route path="pms/kra/create/:designationId" element={<CreateKRAForm />} />
        <Route path="pms/kra/edit/:id" element={<CreateKRAForm />} />
        <Route path="pms/kra/assign" element={<AssignKRAForm />} />
        <Route path="pms/kra/assign/:templateId" element={<AssignKRAForm />} />
        <Route path="pms/kra/employee" element={<EmployeeKRAView />} />
        <Route path="pms/my-kras" element={<EmployeeKRAView />} />
        <Route path="pms/my-reviews" element={<EmployeeSelfReviewDashboard />} />
        <Route path="pms/360-feedback" element={<Feedback360 />} />
        <Route path="pms/kra/manager-review" element={<ManagerKRAReview />} />
        <Route path="pms/manager-reviews" element={<ManagerKRAReview />} />
        <Route path="pms/manager-360-feedback" element={<Manager360FeedbackView />} />
        <Route path="pms/hr/360-feedback-dashboard" element={<HR360FeedbackDashboard />} />
        <Route path="pms/kra/hr-review" element={<HRReview />} />
        <Route path="pms/hr-reviews" element={<HRReview />} />
        <Route path="pms/kra/assignments" element={<KRAAssignments />} />
        {/* Customer Feedback routes */}
        <Route path="feedback/requests" element={<FeedbackRequestList />} />
        <Route path="feedback/requests/:id" element={<ViewCustomerFeedback />} />
        <Route path="feedback/templates" element={<FeedbackTemplateManager />} />
      </Route>
    </Routes>
  );
};

export default LinkRoutes;
